export default __webpack_public_path__ + "static/media/1475.e6010ae4.png";